import { render, staticRenderFns } from "./inbound-order.vue?vue&type=template&id=65fbc4bd&scoped=true&"
import script from "./inbound-order.vue?vue&type=script&lang=js&"
export * from "./inbound-order.vue?vue&type=script&lang=js&"
import style0 from "./inbound-order.vue?vue&type=style&index=0&id=65fbc4bd&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65fbc4bd",
  null
  
)

export default component.exports